import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const DEFAULT_MESSAGE = 'Loading...';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this._loading.asObservable();

  /** What the full-page loader says ("Loading map layer...", ...). */
  private _message = new BehaviorSubject<string>(DEFAULT_MESSAGE);
  public readonly message$ = this._message.asObservable();

  constructor() {}

  show(message?: string) {
    this._message.next(message || DEFAULT_MESSAGE);
    this._loading.next(true);
    // safety net: never leave the page blocked
    setTimeout(() => {
      this.hide();
    }, 7000);
  }

  hide() {
    this._loading.next(false);
  }
}
